export const MAP_TRANSLATIONS = {
  //floating ui functions
  undo: {
    de: 'Rückgängig',
    en: 'Undo',
    fr: 'Annuler',
  },
  redo: {
    de: 'Wiederherstellen',
    en: 'Redo',
    fr: 'Rétablir',
  },
  zoomOut: {
    de: 'Heraus zoomen',
    en: 'Zoom out',
    fr: 'Zoom out',
  },
  zoomToScale: {
    de: 'massstabsgetreu vergrössern',
    en: 'zoom to scale',
    fr: "zoomer à l'échelle",
  },
  zoomIn: {
    de: 'Hinein zoomen',
    en: 'Zoom in',
    fr: 'Zoom in',
  },
  scale: {
    de: 'Massstab',
    en: 'scale',
    fr: 'échelle',
  },
  scaleToUse: {
    de: 'Massstab (1:xxx)',
    en: 'scale (1:xxx)',
    fr: 'échelle (1:xxx)',
  },
  resetRotation: {
    de: 'Ausrichtung zurücksetzen',
    en: 'Reset rotation',
    fr: 'Réinitialiser la rotation',
  },

  //Search
  findPlace: {
    de: 'Ort finden',
    en: 'Find a place',
    fr: 'Trouver emplacement',
  },
  coordinates: {
    de: 'Koordinaten',
    en: 'Coordinates',
    fr: 'Coordonnées',
  },
  streetSearch: {
    de: 'Strassensuche',
    en: 'Street search',
    fr: 'Recherche dans la rue',
  },
  waterSearch: {
    de: 'Gewässersuche (Abschnitt)',
    en: 'Water search (section)',
    fr: "Recherche d'eau (section)",
  },

  //search settings
  filterMapSection: {
    de: 'Nur Ergebnisse aus Kartenausschnitt',
    en: 'Only results from map section',
    fr: 'Seuls les résultats de la section de la carte',
  },
  filterByDistance: {
    de: 'Nur Ergebnisse bis max Distanz',
    en: 'Only results up to max distance',
    fr: "Résultats uniquement jusqu'à la distance maximale",
  },
  maxDistance: {
    de: 'Max Distanz',
    en: 'Max distance',
    fr: 'Distance maximale',
  },
  filterByArea: {
    de: 'Nur Ergebnisse aus definiertem Bereich',
    en: 'Only results from a defined area',
    fr: 'Résulte uniquement d’une zone définie',
  },
  defineArea: {
    de: 'Bereich definieren',
    en: 'Define area',
    fr: 'Définir la zone',
  },
  endDefineArea: {
    de: 'Bereich definieren beenden',
    en: 'End define area',
    fr: 'Quitter définir la zone',
  },
  sortedByDistance: {
    de: 'Sortiert nach Distanz',
    en: 'Sorted by distance',
    fr: 'Triés par distance',
  },
  noSearchResult: {
    de: 'Kein Suchergebnis gefunden.',
    en: 'No search results found',
    fr: 'Aucun résultat de recherche trouvé',
  },

  //guest infos
  guestLimitReachedShort: {
    de: 'Gastmodus Limit erreicht',
    en: 'Guest limit reached',
    fr: "Limite d'invités atteinte",
  },
  guestLimitReached: {
    de: 'Die maximale Anzahl von Elementen für den Gastzugang ist erreicht. Wenn Sie Interesse an einem dauerhaften Zugang zur ZSKarte haben, wenden Sie sich bitte an info@zskarte.ch.',
    en: "The maximum number of elements for guest access has been reached. If yo're interested in having permanent access to the ZSKarte, please contact info@zskarte.ch.",
    fr: "Le nombre maximum d'éléments pour l'accès invité a été atteint. Si vous êtes intéressé par un accès permanent à la ZSKarte, veuillez contacter info@zskarte.ch.",
  },
  guestLimitElements: {
    de: 'Elemente auf der Karte im Gastmodus',
    en: 'Elements on the map in guest mode',
    fr: 'Éléments de la carte en mode invité',
  },

  //draw dialog
  draw: {
    de: 'Zeichnen',
    en: 'Draw',
    fr: 'Dessiner',
  },
  recentlyUsedSigns: {
    de: 'Kürzlich verwendete Signaturen',
    en: 'Recently used signatures',
    fr: 'Signatures récemment utilisées',
  },
  search: {
    de: 'Signatur suchen',
    en: 'Search symbol',
    fr: 'Rechercher un symbole',
  },
  filterByCategory: {
    de: 'Nach Kategorie filtern',
    en: 'Filter by category',
    fr: 'Filtrer par catégorie',
  },
  allCategories: {
    de: 'Alle Kategorien',
    en: 'All categories',
    fr: 'Toutes catégories',
  },
  //category names
  signPlace: {
    de: 'Einrichtungen',
    en: 'Facilities',
    fr: 'Équipement',
  },
  signFormation: {
    de: 'Formationen',
    en: 'Formations',
    fr: 'Formations',
  },
  signAction: {
    de: 'Aktionen',
    en: 'Actions',
    fr: 'Actions',
  },
  signDamage: {
    de: 'Schäden',
    en: 'Damage',
    fr: 'Damage',
  },
  signDanger: {
    de: 'Gefahren',
    en: 'Dangers',
    fr: 'Dangers',
  },
  signEffect: {
    de: 'Auswirkungen',
    en: 'Effects',
    fr: 'Effets',
  },
  signIncident: {
    de: 'Ereignis',
    en: 'Incident',
    fr: 'Incident',
  },
  //drawn types
  text: {
    de: 'Text',
    en: 'Text',
    fr: 'Texte',
  },
  line: {
    de: 'Linie',
    en: 'Line',
    fr: 'Ligne',
  },
  polygon: {
    de: 'Polygon',
    en: 'Polygon',
    fr: 'Polygone',
  },
  rectangle: {
    de: 'Rechteck',
    en: 'Rectangle',
    fr: 'Rectangle',
  },
  oval: {
    de: 'Kreis',
    en: 'Circle',
    fr: 'Cercle',
  },
  freehand: {
    de: 'Freihand',
    en: 'Draw free',
    fr: 'Dessiner libre',
  },

  addSignatureManually: {
    de: 'Bitte fügen Sie die Signatur manuell ein',
    en: 'Please add the signature manually',
    fr: 'Veuillez ajouter la signature manuellement',
  },

  //selected sidebar
  selectedFeature: {
    de: 'Ausgewähltes Feature',
    en: 'Selected Feature',
    fr: 'Fonctionnalité sélectionnée',
  },
  createdBy: {
    de: 'Erstellt von',
    en: 'Created by',
    fr: 'Créé par',
  },
  elementOnOtherLayer: {
    de: 'Element ist auf einer anderen Ebene eingezeichnet und kann nicht editiert werden.',
    en: 'Element is drawn on a different layer and cannot be edited.',
    fr: "L'élément est dessiné sur une autre couche et ne peut pas être édité.",
  },

  //selected sidebar properties
  reportNumber: {
    de: 'Meldenummer',
    en: 'Report number',
    fr: 'Numéro de rapport',
  },
  pressEnter: {
    de: 'Drücken Sie Enter, um die Meldenummer hinzuzufügen',
    en: 'Press enter to add the report number',
    fr: 'Appuyez sur Entrée pour ajouter le numéro du rapport',
  },
  description: {
    de: 'Beschreibung',
    en: 'Description',
    fr: 'Description',
  },
  affectedPersons: {
    de: 'Betroffene Personen',
    en: 'Affected Persons',
    fr: 'Persones affectés',
  },
  hazardCode: {
    de: 'Gefahrennummer',
    en: 'Hazard code',
    fr: 'Numéro de danger',
  },
  unNumber: {
    de: 'UN-Nummer',
    en: 'UN number',
    fr: 'Numéro ONU',
  },
  hierarchyLevel: {
    de: 'Hierarchiestufe',
    en: 'Hierarchy level',
    fr: 'Niveau hiérarchique',
  },
  hierarchyTrupp: {
    de: 'Trupp',
    en: 'Squad',
    fr: 'Équipe',
  },
  hierarchyGruppe: {
    de: 'Gruppe',
    en: 'Group',
    fr: 'Groupe',
  },
  hierarchyZug: {
    de: 'Zug',
    en: 'Platoon',
    fr: 'Section',
  },
  hierarchyKompanie: {
    de: 'Kompanie',
    en: 'Company',
    fr: 'Compagnie',
  },
  hierarchyBataillon: {
    de: 'Bataillon',
    en: 'Battalion',
    fr: 'Bataillon',
  },
  organization: {
    de: 'Organisation',
    en: 'Organization',
    fr: 'Organisation',
  },
  formationDetail: {
    de: 'Nähere Kennzeichnung',
    en: 'Formation detail',
    fr: 'Détail de la formation',
  },
  additionalInfo: {
    de: 'Zusatzangaben',
    en: 'Additional info',
    fr: 'Informations supplémentaires',
  },
  formationNumber: {
    de: 'Nummerierung',
    en: 'Number',
    fr: 'Numéro',
  },
  formationLocation: {
    de: 'Einsatzort',
    en: 'Site of operation',
    fr: "Lieu d'intervention",
  },
  removeFeatureFromMapConfirm: {
    de: 'Möchten Sie dieses Element wirklich von der Karte entfernen?',
    en: 'Do you really want to remove this element from the map?',
    fr: 'Souhaitez-vous vraiment supprimer cet élément de la carte ?',
  },

  //selected sidebar symbol options
  symbol: {
    de: 'Signatur',
    en: 'Symbol',
    fr: 'Symbole',
  },
  selectSymbol: {
    de: 'Auswählen',
    en: 'Select',
    fr: 'Sélectionner',
  },
  replaceSymbol: {
    de: 'Ersetzen',
    en: 'Replace',
    fr: 'Remplacer',
  },
  color: {
    de: 'Farbe',
    en: 'Color',
    fr: 'Couleur',
  },
  //color names
  damage: {
    de: 'Beschädigung',
    en: 'Damage',
    fr: 'Dommage',
  },
  resources: {
    de: 'Einsatzmittel',
    en: 'Resources',
    fr: 'Moyens',
  },
  danger: {
    de: 'Gefahr',
    en: 'Danger',
    fr: 'Danger',
  },
  effects: {
    de: 'Auswirkungen',
    en: 'Effects',
    fr: 'Effets',
  },
  colorPickerMode: {
    de: 'Weitere Farben',
    en: 'More colors',
    fr: 'Plus de couleurs',
  },
  lockFeature: {
    de: 'Position fixieren',
    en: 'Fix position',
    fr: 'Fixer la position',
  },
  labelShow: {
    de: 'Namen anzeigen',
    en: 'Show name',
    fr: 'Afficher le nom',
  },
  distance: {
    de: 'Distanz',
    en: 'Distance',
    fr: 'Distance',
  },
  area: {
    de: 'Fläche',
    en: 'Area',
    fr: 'Région',
  },
  hideSymbol: {
    de: 'Signatur auf Karte verstecken',
    en: 'Hide symbol on map',
    fr: 'Cacher le symbole sur la carte',
  },
  symbolSize: {
    de: 'Grösse',
    en: 'Size',
    fr: 'Taille',
  },
  symbolOffset: {
    de: 'Versatz',
    en: 'Offset',
    fr: 'Décalage',
  },
  endHasDifferentOffset: {
    de: 'Ende hat einen anderen Versatz',
    en: 'End has a different offset',
    fr: 'La fin a un décalage différent',
  },
  symbolOffsetEnd: {
    de: 'Versatz Ende',
    en: 'Offset End',
    fr: 'Décalage fin',
  },
  rotate: {
    de: 'Rotieren',
    en: 'Rotate',
    fr: 'Tourner',
  },
  defaultValues: {
    de: 'Standardwerte zurücksetzen',
    en: 'Reset Default Values',
    fr: 'Valeurs par défaut',
  },

  //selected sidebar line options
  solidLine: {
    de: 'Durchgezogen',
    en: 'Solid',
    fr: 'Continue',
  },
  dottedLine: {
    de: 'Gepunktet',
    en: 'Dotted',
    fr: 'Pointillés',
  },
  dashedLine: {
    de: 'Gestrichelt',
    en: 'Dashed',
    fr: 'Tirets',
  },
  thinDashedLine: {
    de: 'Gestrichelt (Dünn)',
    en: 'Dashed (thin)',
    fr: 'Tirets (fins)',
  },
  arrow: {
    de: 'Pfeil',
    en: 'Arrow',
    fr: 'Flèche',
  },
  none: {
    de: 'Keiner',
    en: 'None',
    fr: 'Aucun',
  },
  thin: {
    de: 'Dünn',
    en: 'Thin',
    fr: 'Fine',
  },

  //selected sidebar polygon options
  fillPattern: {
    de: 'Muster',
    en: 'Pattern',
    fr: 'Modèle',
  },
  filled: {
    de: 'Gefüllt',
    en: 'Filled',
    fr: 'Rempli',
  },
  hatched: {
    de: 'Schraffiert',
    en: 'Hatched',
    fr: 'Hachuré',
  },
  crossed: {
    de: 'Gekreuzt',
    en: 'Crossed',
    fr: 'Croisé',
  },
  spacing: {
    de: 'Abstand',
    en: 'Spacing',
    fr: 'Espacement',
  },
  angle: {
    de: 'Winkel',
    en: 'Angle',
    fr: 'Angle',
  },
  width: {
    de: 'Dicke',
    en: 'Width',
    fr: 'Largeur',
  },

  //selected sidebar text options
  yourText: {
    de: 'Ihr Text',
    en: 'Your text',
    fr: 'Votre texte',
  },
  font: {
    de: 'Schrift',
    en: 'Font',
    fr: 'Police',
  },
  fontSize: {
    de: 'Schriftgrösse',
    en: 'Font size',
    fr: 'Taille de police',
  },

  //selected sidebar functions
  functions: {
    de: 'Funktionen',
    en: 'Functions',
    fr: 'Fonctions',
  },
  moveToTop: {
    de: 'In den Vordergrund',
    en: 'Send to front',
    fr: 'Passer au premier plan',
  },
  moveToBottom: {
    de: 'In den Hintergrund',
    en: 'Send to back',
    fr: 'Passer au fond',
  },
  group: {
    de: 'Gruppieren',
    en: 'Group',
    fr: 'Grouper',
  },
  chooseGroupingArea: {
    de: 'Zu gruppierende Fläche auswählen',
    en: 'Choose the element to group with',
    fr: 'Sélectionnez la zone à grouper',
  },
  cancelGrouping: {
    de: 'Gruppieren abbrechen',
    en: 'Cancel grouping',
    fr: 'Annuler le groupement',
  },
  ungroup: {
    de: 'Gruppierung aufheben',
    en: 'Ungroup',
    fr: 'Dégrouper',
  },
  drawHole: {
    de: 'Loch zeichnen',
    en: 'Draw a hole',
    fr: 'Dessiner un trou',
  },
  defineCoordinates: {
    de: 'Koordinaten definieren',
    en: 'Define coordinates',
    fr: 'Définir les coordonnées',
  },
  copy: {
    de: 'Kopie',
    en: 'Copy',
    fr: 'Copie',
  },
  delete: {
    de: 'Löschen',
    en: 'Delete',
    fr: 'Effacer',
  },
};
